/**
 * Pending Bookings Cache Service
 *
 * Feeds the SOFT HOLD layer of inventory availability. A booking sits in
 * `pendingBookings` from the moment checkout starts until payment confirms it — for a
 * card that is a few minutes, for a cash booking it spans the waiver plus a walk to
 * the register. Until this existed, nothing counted those, so two customers could each
 * be shown "1 available" and both check out.
 *
 * Firestore rules already permit public reads of pendingBookings
 * (firestore.rules:88 and :182), so unauthenticated customers can subscribe too.
 */

import { subscribeToCollection } from "../db_calls";
import { getCollectionPath } from "../utils/dbPaths";
import { usePendingBookings } from "../stores";

export const initializePendingBookingsCache = () => {
  const collectionPath = getCollectionPath("pendingBookings");
  console.log(`📡 Setting up pendingBookings subscription for path: ${collectionPath}`);

  const unsubscribe = subscribeToCollection(
    collectionPath,
    (pending, error) => {
      if (error) {
        console.error("❌ Error in pendingBookings subscription:", error);
        return;
      }
      usePendingBookings.getState().setPendingBookings(pending || []);
    },
    {
      // BOUNDED ON PURPOSE. Abandoned checkouts are never pruned from this collection,
      // so it grows without limit — and this listener runs for every visitor, including
      // unauthenticated customers. An unbounded listener would mean the read cost of
      // every page load climbing forever.
      //
      // Only recent documents matter: holds expire after HOLD_WINDOW_MS (10 minutes), and the
      // awaiting-cash alert is for today's unfinished transactions. Anything outside the
      // newest 200 is abandoned and consequential to nobody.
      orderBy: { field: "createdAt", direction: "desc" },
      limit: 200,
    }
  );

  return unsubscribe;
};
